import { render, staticRenderFns } from "./PhotovoltaicDetail.vue?vue&type=template&id=f53e596a&scoped=true&"
import script from "./PhotovoltaicDetail.vue?vue&type=script&lang=js&"
export * from "./PhotovoltaicDetail.vue?vue&type=script&lang=js&"
import style0 from "./PhotovoltaicDetail.vue?vue&type=style&index=0&id=f53e596a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53e596a",
  null
  
)

export default component.exports